export const limitString = (string: string, limit: number) => {
  return `${string.substring(0, limit)}${string.length > limit ? '...' : ''}`;
};
